import ApplicationController from '../support/application_controller';

export default class extends ApplicationController {
  renew(event) {
    event.preventDefault();
    event.stopPropagation();

    Cookiebot.renew();
  }
}